<template>
  <el-container>
    <el-header class="table-header">
      <router-link :to="{name:'userAdd',path:'/userAdd'}">
        <el-button type="primary" size="small">{{$t('common.Add')}}</el-button>
      </router-link>
      <el-button icon="el-icon-search" @click="search('refresh')" align="center" size="small">{{$t('common.Search')}}</el-button>
      <el-button icon="el-icon-refresh-left" @click="reset" align="center" size="small">{{$t('common.Reset')}}</el-button>
    </el-header>
    <el-main class="table-main">
        <el-form :model="formSearch" ref="formSearch" label-width="80px" size="mini" class="table-form">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('common.Code')" prop="code" size="mini">
                <el-input v-model="formSearch.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.user.Name')" prop="nameCn" size="mini">
                <el-input v-model="formSearch.nameCn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.user.UnitName')" prop="deptName" size="mini">
                <el-input v-model="formSearch.deptName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.Province')" prop="provinceCode" size="mini">
                <el-select v-model="formSearch.provinceCode"
                           @change="provinceChange">
                  <el-option
                    v-for="item in selectData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('common.City')" prop="cityCode" size="mini">
                <el-select v-model="formSearch.cityCode" @change="cityChange">
                  <el-option
                    v-for="item in selectCity"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
            <el-form-item :label="$t('common.Area')" prop="areaCode">
              <el-select v-model="formSearch.areaCode" @change="areaChange">
                <el-option
                  v-for="item in selectArea"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="tableData"
          border highlight-current-row stripe
          style="width: 100%"
          :row-class-name="tableRowClassName">
          <el-table-column
            type="index"
            style="width: 10%">
          </el-table-column>
          <el-table-column
            align="center"
            prop="code"
            :label="$t('common.Code')"
            width="90%">
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('base.info.user.Name')"
            width="100%"
            prop="nameCn">
          </el-table-column>
          <el-table-column
            align="center"
            prop="sex"
            :label="$t('common.Sex')"
            width="50%">
            <template slot-scope="scope">
              <p v-if="scope.row.sex==1">{{$t('common.Man')}}</p>
              <p v-if="scope.row.sex==0">{{$t('common.Woman')}}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="birthday"
            :label="$t('common.Birthday')"
            align="center"
            width="110%"
            :formatter="dateFormat">
          </el-table-column>
          <el-table-column
            prop="beginDay"
            :label="$t('base.info.user.BeginDay')"
            align="center"
            width="130%"
            :formatter="dateFormat">
          </el-table-column>
          <el-table-column
            prop="endDay"
            :label="$t('base.info.user.EndDay')"
            align="center"
            width="130%"
            :formatter="dateFormat">
          </el-table-column>
          <el-table-column
            prop="orgName"
            :label="$t('base.info.user.OrgName')"
            width="90%"
            v-if="false"
            align="center">
          </el-table-column>
          <el-table-column
            prop="orgId"
            :label="$t('base.info.user.OrgId')"
            width="90%"
            v-if="false"
            align="center">
          </el-table-column>
          <el-table-column
            prop="deptName"
            :label="$t('base.info.user.UnitName')"
            width="90%"
            align="center">
          <el-table-column
            prop="deptId"
            :label="$t('base.info.user.UnitId')"
            width="90%"
            v-if="false"
            align="center">
          </el-table-column>
          </el-table-column>
          <el-table-column
            prop="mobile"
            :label="$t('common.Mobile')"
            align="center"
            width="150%">
          </el-table-column>
          <el-table-column
            prop="telephone"
            :label="$t('common.Tel')"
            align="center"
            width="150%">
          </el-table-column>
          <el-table-column
            prop="email"
            label="EMAIL"
            align="center"
            width="180%">
          </el-table-column>
          <el-table-column
            prop="provinceName"
            :label="$t('common.Province')"
            width="110%"
            align="center">
          </el-table-column>
          <el-table-column
            prop="cityName"
            :label="$t('common.City')"
            width="110%"
            align="center">
          </el-table-column>
          <el-table-column
            prop="areaName"
            :label="$t('common.Area')"
            width="110%"
            align="center">
          </el-table-column>
          <el-table-column
            :label="$t('common.Address')"
            width="200%"
            align="center">
          </el-table-column>
          <el-table-column
            :label="$t('common.Remark')"
            width="120%"
            align="center">
          </el-table-column>
          <el-table-column
            prop="status"
            :label="$t('common.Status')"
            align="center"
            width="75%">
            <template slot-scope="scope">
              <span v-if="scope.row.status==50">{{$t('common.Normal')}}</span>
              <span v-if="scope.row.status==40">{{$t('common.Disable')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="modifyTime"
            :label="$t('common.ModifyTime')"
            align="center"
            width="140%"
            sortable
            :formatter="dateFormat">
          </el-table-column>

          <el-table-column align="center" :label="$t('common.Operate')" width="150px" fixed="right">
            <template slot-scope="scope">
              <router-link :to="{name: 'userEdit', params: {row:scope.row}}">
                <el-button size="mini" type="text">{{$t('common.Edit')}}</el-button>
              </router-link>
              <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">{{$t('common.Delete')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-main>
    <el-footer class="table-footer">
      <table-page ref="userListPage" :url="userListUrl" :form="formSearch"
                  @page-change="convert"></table-page>
    </el-footer>
  </el-container>
</template>

<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import TablePage from '@/components/TablePage'

export default {
  data () {
    return {
      userListUrl: this.global.BASE_ACL + '/user/findAll',
      tableData: [],
      tree: [],
      formSearch: {
        code: '',
        nameCn: '',
        deptName: '',
        provinceCode: '',
        cityCode: '',
        areaCode: ''
      },
      selectData: [],
      selectCity: [],
      selectArea: []
    }
  },
  components: {
    TablePage
  },
  methods: {
    provinceChange (val) {
      this.formSearch.cityCode = ''
      this.loadCity(val)
    },
    cityChange (val) {
      this.formSearch.areaCode = ''
      this.loadArea(val)
    },
    areaChange () {
      this.$forceUpdate()
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.status === 30) {
        return 'warning-row'
      }
      return ''
    },
    changeToName (row, column) {
      let item = this.tree.find(item => {
        return item.code === row[column.property]
      })
      return item.label
    },
    dateFormat (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    handleDelete (index, row) {
      this.$confirm(this.$t('common.DeleteConfirm'), this.$t('common.Tips'), {
        confirmButtonText: this.$t('common.Ok'),
        cancelButtonText: this.$t('common.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.userList.userDelete(this.qs.stringify({id: row.id})).then((response) => {
          this.$refs['userListPage'].getTableData()
          if (response.data.status === 'Y') {
            this.$message({
              message: response.data.message,
              type: 'success'
            })
          } else {
            this.$message({
              message: response.data.message,
              type: 'error'
            })
          }
        }).catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
      })
    },
    filterTag (value, row) {
      return row.tag === value
    },
    convert (table) {
      this.tableData = table.data
    },
    search (param) {
      this.$refs['userListPage'].getTableData(param)
    },
    reset () {
      this.formSearch = {}
    },
    loadProvince () {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/pca/findProvince',
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        this.selectData = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    loadCity (code) {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/pca/findCity',
        data: this.qs.stringify({
          provinceCode: code
        }),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        this.selectCity = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    loadArea (code) {
      this.$axios({
        method: 'post',
        url: this.global.BASE_INFO + '/pca/findArea',
        data: this.qs.stringify({
          cityCode: code
        }),
        headers: {
          certificate: Cookies.get(`token_${window.location.port}`)
        }
      }).then((response) => {
        this.selectArea = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    initAllOrg () {
      this.$api.orgList.findAll().then((response) => {
        this.tree = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  created () {
    this.loadProvince()
    this.loadCity()
    this.loadArea()
    this.initAllOrg()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/user/userList.vue